import { render, staticRenderFns } from "./CaseTime.vue?vue&type=template&id=a10802d2&"
import script from "./CaseTime.vue?vue&type=script&lang=ts&"
export * from "./CaseTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports